import { render } from "./TenantSelectionPopup.vue?vue&type=template&id=7d20067f&scoped=true"
import script from "./TenantSelectionPopup.vue?vue&type=script&lang=js"
export * from "./TenantSelectionPopup.vue?vue&type=script&lang=js"

import "./TenantSelectionPopup.vue?vue&type=style&index=0&id=7d20067f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d20067f"]])

export default __exports__